/**
 * AimReticle — HUD element (extracted from PixiHUDRenderer.js in Phase 3D).
 *
 * create(hud) builds the PIXI objects into hud.elements.aimReticle,
 * position(hud) lays them out for hud.screenWidth/Height, update(hud, …) redraws
 * from game state. `hud` is the PixiHUDRenderer coordinator: it owns
 * hudContainer, elements, screen size, _createText() and send().
 */
import * as PIXI from 'pixi.js';

export function create(hud) {
  const container = new PIXI.Container();
  container.visible = false;
  const radius = 12;

  const circle = new PIXI.Graphics();
  circle.setStrokeStyle({ width: 2, color: 0xffffff, alpha: 0.85 });
  circle.circle(0, 0, radius);
  circle.stroke();
  container.addChild(circle);

  const lines = new PIXI.Graphics();
  lines.setStrokeStyle({ width: 2, color: 0xffffff, alpha: 0.85 });
  lines.moveTo(-radius - 6, 0);
  lines.lineTo(-radius + 2, 0);
  lines.moveTo(radius - 2, 0);
  lines.lineTo(radius + 6, 0);
  lines.moveTo(0, -radius - 6);
  lines.lineTo(0, -radius + 2);
  lines.moveTo(0, radius - 2);
  lines.lineTo(0, radius + 6);
  lines.stroke();
  container.addChild(lines);

  hud.hudContainer.addChild(container);
  hud.elements.aimReticle = container;
}

export function update(hud, gameState) {
  const reticle = hud.elements.aimReticle;
  if (!reticle) return;
  const mouse = gameState?.inputState?.mouse;
  if (!mouse) {
    reticle.visible = false;
    return;
  }
  reticle.visible = true;
  reticle.position.set(mouse.x, mouse.y);

  // Debug: log mouse position once
  if (!hud._reticleLoggedOnce) {
    console.log('[PixiHUD] Reticle position:', mouse.x, mouse.y);
    console.log('[PixiHUD] HUD screen dimensions:', hud.screenWidth, 'x', hud.screenHeight);
    console.log('[PixiHUD] hudContainer position:', hud.hudContainer.position.x, hud.hudContainer.position.y);
    hud._reticleLoggedOnce = true;
  }
}
